var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProtect = function SvgProtect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.167q-1.458-.365-2.396-1.693a4.94 4.94 0 0 1-.937-2.912V2.083L5 .833l3.333 1.25v2.48a4.94 4.94 0 0 1-.937 2.91Q6.458 8.802 5 9.168m0-.646a3.67 3.67 0 0 0 1.828-1.339q.724-.975.85-2.182H5V1.51L2.292 2.52v2.042q0 .126.005.214.005.089.026.224H5z"
  })));
};
export default SvgProtect;